import { BaseService, Service, Permission } from "/@/cool";
@Service("takephotoOrder")
class TakephotoOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";

		this.permission["modelingMake"] = prefix + "modelingMake";
		this.permission["takephotoImages"] = prefix + "takephotoImages";
		this.permission["takephotoPreviewImages"] = prefix + "takephotoPreviewImages";
		this.permission["takephotoCartoonPreviewImages"] = prefix + "takephotoCartoonPreviewImages";
		this.permission["takephotoAllImages"] = prefix + "takephotoAllImages";
		this.permission["takephotoImageCount"] = prefix + "takephotoImageCount";
		this.permission["retake"] = prefix + "retake";
		this.permission["customerService"] = prefix + "customerService";
		this.permission["canPostMakeModel"] = prefix + "canPostMakeModel";
		this.permission["cancel"] = prefix + "cancel";
		this.permission["shopTicketInfo"] = prefix + "shopTicketInfo";
		this.permission["printedOrderPage"] = prefix + "printedOrderPage";
		this.permission["previewScene"] = prefix + "previewScene";
		this.permission["previewModel"] = prefix + "previewModel";
	}

	modelingMake(params: any) {
		return this.request({
			url: "/modelingMake",
			method: "POST",
			data: { ...params }
		});
	}

	takephotoImages(params: any) {
		return this.request({
			url: "/takephotoImages",
			method: "POST",
			data: { ...params }
		});
	}

	takephotoPreviewImages(params: any) {
		return this.request({
			url: "/takephotoPreviewImages",
			method: "POST",
			data: { ...params }
		});
	}

	takephotoCartoonPreviewImages(params: any) {
		return this.request({
			url: "/previewCartoonImages",
			method: "POST",
			data: { ...params }
		});
	}

	takephotoAllImages(params: any) {
		return this.request({
			url: "/takephotoAllImages",
			method: "POST",
			data: { ...params }
		});
	}

	takephotoImageCount(params: any) {
		return this.request({
			url: "/takephotoImageCount",
			method: "POST",
			data: { ...params }
		});
	}

	retake(params: any) {
		return this.request({
			url: "/retake",
			method: "POST",
			data: { ...params }
		});
	}

	customerService(params: any) {
		return this.request({
			url: "/customerService",
			method: "POST",
			data: { ...params }
		});
	}

	canPostMakeModel(params: any) {
		return this.request({
			url: "/canPostMakeModel",
			method: "POST",
			data: { ...params }
		});
	}

	cancel(params: any) {
		return this.request({
			url: "/cancel",
			method: "POST",
			data: { ...params }
		});
	}

	shopTicketInfo(params: any) {
		return this.request({
			url: "/shopTicketInfo",
			method: "POST",
			data: { ...params }
		});
	}

	// 已完成打印的订单
	printedOrderPage(params: any) {
		return this.request({
			url: "/printedOrderPage",
			method: "POST",
			data: { ...params }
		});
	}
}
export default TakephotoOrder;
